import React from 'react'
import { format } from 'd3-format'
import { toPairs } from 'ramda'

const commas = format(',')

const LabelVal = ({ label, val }) => {
  let value = Array.isArray(val) ? val.join(', ') : val
  if (label === 'Units affected') {
    value = commas(val)
  }
  return (
    <div>
      <strong>{label}:</strong> {value}
    </div>
  )
}

const BasicDetails = ({ data }) =>
  toPairs(data)
    .filter(([key, val]) => val)
    .map(([key, val]) => <LabelVal key={key} label={key} val={val} />)

export default BasicDetails
